import { UpperCasePipe, CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { analytics } from '@app/events/segment/analytics';
import { RIASEC_CATEGORIES } from '@app/utils/constants';
import { DebugModeService } from '@app/services/debug-mode.service';

@Component({
  selector: 'app-scores',
  imports: [
    CommonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
    UpperCasePipe
  ],
  templateUrl: './scores.component.html',
  styleUrl: './scores.component.css'
})
export class ScoresComponent implements OnInit {
  riasecPercentages: any;
  categories = RIASEC_CATEGORIES;
  categoryKeys: string[] = [];
  showFootnote: boolean = false;
  showButton: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    public debugModeService: DebugModeService,
  ) {}

  ngOnInit() {
    this.riasecPercentages = this.calcRiasecPercentages();
    // Hide button if opened from career-details viewProfile
    const source = this.data?.source;
    this.showButton = source !== 'viewProfile' && source !== 'myProfile' && source !== 'buildPlan';
  }

  get showCloseButton(): boolean {
    return this.data?.source === 'viewProfile' || this.data?.source === 'myProfile' || this.data?.source === 'buildPlan';
  }

  getRawScore(category: string): number {
    const riasecData = this.data?.riasec || this.data || {};
    return riasecData[category] ?? 0;
  }

  createAccountBtn() {
    analytics.track('Survey Exit', { section: 'survey' });
    this.router.navigate(['/career-matches']);
  }

  calcRiasecPercentages() {
    const maxScore = 30;
    const percentages: any = {};

    // Get riasec data - handle both formats
    const riasecData = this.data?.riasec || this.data || {};
    
    // sort scores in descending
    const sortedEntries = Object.entries(riasecData).sort(([, a], [, b]) => (b as number) - (a as number));
    const sortedScores = Object.fromEntries(sortedEntries) as Record<string, number>;
    this.categoryKeys = Object.keys(sortedScores);

    Object.entries(sortedScores).forEach(([cat, score]) => {
      const percentage = Math.ceil((score / maxScore) * 100);
      const { qualifier, star } = this.riasecPercentageQualifier(percentage);

      percentages[cat] = {
        value: percentage,
        qualifier: qualifier,
        star: star,
      }
    });

    return percentages;
  }

  // 6 different qualifiers evenly divided
  // update: calculate the star count (total 5 stars)
  riasecPercentageQualifier(percentage: number) {
    let qualifier = "";
    let star = "";
    if (percentage > 80) {
      qualifier = "Very interested";
      star = "5";
    } else if (percentage > 60) {
      qualifier = "Interested";
      star = "4";
    } else if (percentage > 40) {
      qualifier = "Neutral";
      star = "3";
    } else if (percentage > 20) {
      qualifier = "Uninterested";
      star = "2";
    } else {
      qualifier = "Very uninterested";
      star = "1";
    }
    return { qualifier, star };
  }

  toggleFootNote() {
    this.showFootnote = !this.showFootnote;
    if (this.showFootnote) {
      analytics.track('Survey Info Open', { section: 'survey' });
    }
  }
}
